import { render, staticRenderFns } from "./ReturnGoodsEditing.vue?vue&type=template&id=39b3a9f4&scoped=true"
import script from "./ReturnGoodsEditing.vue?vue&type=script&lang=js"
export * from "./ReturnGoodsEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b3a9f4",
  null
  
)

export default component.exports